import {Table as TableAntd} from 'antd';
import {TableProps} from 'antd';
import './index.style.less';

export type {TableColumnsType as ColumnsType} from 'antd';

export interface DataType {
  key: React.Key;
  name: string;
  age: number;
  address: string;
}

export const Table = (props: TableProps<any>) => {
  const rowClassName = (record: any, index: number) => {
    const backgroundColor = index % 2 === 0 ? 'white' : 'gray';
    return `rowStyle ${backgroundColor}`;
  };

  return <TableAntd {...props} rowClassName={rowClassName} />;
};
